/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent, useMemo } from "react"
import Grid from "../../../components/Grid/Grid"
import SelectItem from "../../../components/Grid/SelectItem"
import ArtistItem from "../../Artists/Item"
import ArtPieceItem from "../../ArtPieces/Item"
import ExhibitionItem from "../../Exhibitions/Item"
import SpaceItem from "../../Spaces/Item"

interface iProps {
  dataType: string
  selected: any[]
  onSelect: (doc: any) => void
  query?: any
  data?: any
}

const FeaturedSelection: FunctionComponent<iProps> = ({
  dataType,
  selected,
  data,
  onSelect,
}) => {
  const Item = useMemo<any>(() => {
    switch (dataType) {
      case "ArtPieces":
        return ArtPieceItem
      case "Exhibitions":
        return ExhibitionItem
      case "Artists":
        return ArtistItem
      case "Spaces":
        return SpaceItem
      default:
        break
    }
  }, [dataType, selected])

  return (
    <Grid>
      {data?.map((d: any) => (
        <SelectItem<any>
          key={d._id}
          onClick={() => {
            onSelect(d)
          }}
          item={d}
          isSelected={!!selected.find((s) => s._id === d._id)}
        >
          <Item {...d} />
        </SelectItem>
      ))}
    </Grid>
  )
}

export default FeaturedSelection
